var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenInNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.792 35q-1.125 0-1.959-.833Q5 33.333 5 32.208V7.792q0-1.125.833-1.959Q6.667 5 7.792 5h10.25q.583 0 .979.396t.396.979q0 .625-.396 1.021-.396.396-.979.396H7.792v24.416h24.416v-10.25q0-.583.417-.979t1-.396q.583 0 .979.396t.396.979v10.25q0 1.125-.833 1.959-.834.833-1.959.833Zm7.25-10.042q-.375-.375-.396-.958-.021-.583.396-.958l15.25-15.25h-6.709q-.583 0-.979-.417t-.396-1q0-.583.396-.979T23.583 5h10.042q.583 0 .979.396t.396.979v10.042q0 .583-.396.979t-.979.396q-.625 0-1.021-.396-.396-.396-.396-.979V9.75L16.958 25q-.375.375-.937.375-.563 0-.979-.417Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/OpenInNew.4e32eae677a60ecdecd9322569618827.svg";
export { ForwardRef as ReactComponent };